// Before anything that renders: the `@font-face` rules have to be in the
// document when the first paint happens, or the shell paints in the fallback
// and reflows once Inter arrives.
import "./fonts.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import { initSciChart } from "./lib/scichart-bootstrap";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { BRAND } from "./lib/brand-current";
import { startUpdater } from "./lib/sw-update";
import { capturePlanIntent } from "./lib/billing";

// Apply the SciChart license + WASM config before any chart surface is created.
initSciChart();

// **The service worker's one registration**, and the update checks that ride on
// it — `vite.config.ts` injects no `registerSW.js` beside this. Before render, so
// the controller is read before anything can swap it, and the bar's state exists
// before the bar does. See the module for when an update reloads and when it asks.
startUpdater({ register: registerSW });

// A landing page's Choose EOD / Go Live, kept before the sign-in screen can
// navigate the URL away. `Workspace` takes it once signed in.
capturePlanIntent();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found");
}

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary where={BRAND.identity.name}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
